import * as React from "react";
import Assets from "src/presentation/assets/img/assets";
import styled from "styled-components";
import BtnLinkBorderSmall from "../../../common/atom/btn/btn_link_border_small";
import Paragraph from "../../../common/atom/text/paragraph";

const commonlySearchedWords: string[] = [
  "ビッグデータ",
  "サイバーセキュリティ",
  "新規事業開発",
  "ボストンコンサルティング",
  "NTTデータ",
  "社外取締役",
  "常勤監査役",
  "IPO支援",
  "PR強化",
  "Webマーケティング",
  "人事制度",
];

interface IProps {}

export const ClientScoutCustomerCommonlySearchedWords: React.FC<IProps> = (
  props
) => {
  const {} = props;

  return (
    <Wrapper>
      <TitleWrapper>
        <Paragraph bold={true}>よく検索されるワード</Paragraph>
        <LinkIconContainer>
          <LinkIcon src={Assets.help} onClick={() => {}} />
          <Tooltip>
            エキスパートのフリーワード検索機能です。
            <br />
            経歴や資格、専門領域など、なるべく単語ベースで検索、
            <br />
            また複数ある場合はスペース区切りで複数の単語を並べて検索をすると
            <br />
            条件に合致するエキスパートが見つけやすくなります。
          </Tooltip>
        </LinkIconContainer>
      </TitleWrapper>
      {commonlySearchedWords.map((commonlySearchedWord) => {
        return (
          <BtnLinkWrapper key={commonlySearchedWord}>
            <BtnLinkBorderSmall
              to={`/client/scout/customers?q=${commonlySearchedWord}&p=1`}
            >
              {commonlySearchedWord}
            </BtnLinkBorderSmall>
          </BtnLinkWrapper>
        );
      })}
    </Wrapper>
  );
};

export default ClientScoutCustomerCommonlySearchedWords;

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

const TitleWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  position: relative;
`;

const BtnLinkWrapper = styled.div`
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
`;

const LinkIcon = styled.img`
  display: block;
  margin-left: 10px;
  cursor: pointer;
`;

const Tooltip = styled.div`
  position: absolute;
  top: 30px;
  left: 0px;
  background-color: #333;
  color: white;
  padding: 16px;
  border-radius: 5px;
  font-size: 10px;
  line-height: 14px;
`;

const LinkIconContainer = styled.div`
  & > ${Tooltip} {
    display: none;
  }

  // ホバー時にツールチップを表示する
  &:hover > ${Tooltip} {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customers/client_scout_customers_commonly_searched_words.tsx